<template>
  <div class="play_warp" id="play_warp" :class="{orienta: isOrienta}">
      <div id="J_prismPlayer"></div>
      <!-- <div class="block_module" v-if="isPlay" @click="onModule">
          <van-icon name="shrink" class="shrink" />
      </div> -->
  </div>
</template>

<script>
import { Toast, Icon } from 'vant';
import $ from 'jquery';
export default {
 name:'play',
 props:{
     /**
      * 当前播放信息
      */
     currentlyPlay:{
         type:Object,
         default(){
             return {}
         }
     },
      /** 监管信息 */
     TrainBasicInfo:{
       type:Object,
       default(){
           return {}
       }
     },
     /**
      * 是否允许拖拽 1 0
      * 0: 可以拖动
      * 1: 不可以拖动
      */
     isDraw:{
         type:Number,
         default:0
     },
     /** 防倍速 */
     isDoubleSpeed:{
       type:Number,
       default:0
     },
     objAli:{
         type:Object,
         default(){
             return {}
         }
     }
 },
 data(){
     return{
         isActive:false, // ios全屏样式
         isPlay: false,
         isOrienta: false, // 播放器横屏
         videoInfoNv: {}, // 原生video标签集合属性
         player:null, // 阿里云播放器实例
         TimeArray: [], // 用户已经观看 记录时间轴
         hasTagNv:false, // 标识是否可以快进
         frontTime:0,// 用户已经 最后一次观看的时间
         duration:0,// 总时长
         startTime:0,// 已经播放的时间
         timer:null,
         showAlertArr:[],// 弹屏次数 时间段记录
         timeTStr:0, //视频当前播放时间点 用来弹出弹屏设置
         audioImg:'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/course/photo.png',
         skinLayout:[
             {name: "bigPlayButton", align: "cc", x: 0, y: 0},
             {name: "H5Loading", align: "cc"},
             {
                 name: "controlBar", align: "blabs", x: 0, y: 0,
                 children: [
                     {name: "progress", align: "tlabs", x: 0, y: 0},
                     {name: "playButton", align: "tl", x: 15, y: 12},
                     {name: "timeDisplay", align: "tl", x: 10, y: 5},
                     {name: "setting", align: "tr", x: 15, y: 12 },
                     {name: "volume", align: "tr", x: 5, y: 10},
                 ]
             }
         ],
         isApp:false,
         isVideoTime:false,
         isReady: true,
         isOnce:true
     }
 },
 destroyed () {
      this.isReady = false;
      this.isOnce = false;
  },
 created() {
     // console.log(this.currentlyPlay,'currentlyPlay===子组建');
     // console.log('TrainBasicInfo子组建',this.TrainBasicInfo);
     console.log('isDraw子组建',this.isDraw)
     this.createdMeth()
     window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", this.onOrient,false)
     this.$WDJSBridge.useGetAppVersion().then(res=>{
       console.log('获取版本号成功', res)
       this.isApp = res?true:false;
     }).catch(err=>{
       console.log('获取版本号失败', err)
     })
 },
 beforeDestroy(){
     window.removeEventListener("onorientationchange" in window ? "orientationchange" : "resize", this.onOrient,false)
 },
 methods:{
     // 手机横屏
     onOrient() {
         // iPhone X  适配长脸屏
         if(/iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812){
             this.isOrienta = !this.isOrienta
         }
     },
     createdMeth() {
         this.theFirst = true;
         let userAgent = navigator.userAgent.toLowerCase()

         // 安卓浏览器
         let isAndroid = userAgent.indexOf('android') > -1 || userAgent.indexOf('linux') > -1

         this.isAndroid = isAndroid
         this.skinLayoutAndroid = [
                 {name: "bigPlayButton", align: "cc", x: 0, y: 0},
                 {name: "H5Loading", align: "cc"},
                 {
                     name: "controlBar", align: "blabs", x: 0, y: 0,
                     children: [
                         {name: "progress", align: "tlabs", x: 0, y: 0},
                         {name: "playButton", align: "tl", x: 15, y: 12},
                         {name: "timeDisplay", align: "tl", x: 10, y: 5},
                         {name: "setting", align: "tr", x: 15, y: 12 },
                         {name: "volume", align: "tr", x: 5, y: 10},
                         {name: "fullScreenButton", align: "tr", x: 12, y: 12},
                     ]
                 }
         ]
     },
     // setWH() {
     //   let width = document.documentElement.clientWidth,
     //       height = document.documentElement.clientHeight,
     //       wrapper = document.getElementById("play_warp"),
     //       style = "";
     //     style += "width:" + height + "px;";// 注意旋转后的宽高切换
     //     style += "height:" + width + "px;";
     //     style += "-webkit-transform: rotate(90deg); transform: rotate(90deg);";
     //     // 注意旋转中点的处理
     //     style += "-webkit-transform-origin: " + width / 2 + "px " + width / 2 + "px;";
     //     style += "transform-origin: " + width / 2 + "px " + width / 2 + "px;";
     //     wrapper.style.cssText = style;
     // },
     async onModule(){
         if(this.isAndroid){
             return
         }
         if(this.isActive){
             this.player.setPlayerSize(
                 '100%',
                 '210px'
             )
         } else {
             this.player.setPlayerSize(
                 '100%',
                 '80vh'
             )
         }

         // if(this.isActive){
         //     this.player.setPlayerSize(
         //         '100%',
         //         '210px'
         //     )
         //   //  let  wrapper = document.getElementById("play_warp");
         //   //  wrapper.style.width = '100%';
         //   //  wrapper.style.height = "210px"
         //   //  wrapper.style.transform = "rotate(0deg)";
         // } else {
         //     // await this.$parent.playerDispose()
         //     // this.player.dispose()
         //   //  this.getAliplayer(this.$parent.videoInfo.source,this.$parent.videoInfo);
         //     // this.setWH();
         //   // this.player.setRotate(90)
         //   this.player.setPlayerSize(
         //       '100%',
         //       '100%'
         //   )

         // }
         this.isActive = !this.isActive
     },

     returnPortrait(){
         this.player.setPlayerSize(
             '100%',
             '210px'
         )
         let  wrapper = document.getElementById("play_warp");
         wrapper.style.width = '100%';
         wrapper.style.height = "210px"
         wrapper.style.transform = "rotate(0deg)";
         this.isActive = !this.isActive
     },
     // 获取显示弹窗提示的时间点的数组
     getShowAlertArrNum(totalTime,nums){
          console.log('次数弹屏')
         let totalNum = totalTime/(nums+1)
         this.showAlertArr = [];
         for(let i = 0; i<= nums+1; i++) {
             this.showAlertArr.push(parseInt(totalNum*i))
         }
         this.showAlertArr.shift()
         this.showAlertArr.pop()
     },
     /**
      * 弹屏
      */
     setDialogNum(){
         console.log('setDialogNum进入');
        //  console.log(parseInt(this.player.getCurrentTime()),this.timeTStr,'parseInt(this.player.getCurrentTime())')
         if(this.timeTStr  !==  parseInt(this.player.getCurrentTime())){
             // console.log('setDialogNum进入1111');/
             // console.log('this.showAlertArr',this.showAlertArr);
             if(this.showAlertArr.length>0){
                 if(this.showAlertArr.indexOf (parseInt(this.player.getCurrentTime()))!==-1){
                   console.log('pause')
                      // 弹屏之前存一下当前播放时间
                      let video = document.querySelector('video')
                      sessionStorage.setItem('currentVideoTime',video.currentTime)
                      // 如果video 进入全屏状态则退出全屏
                      if(this.checkIsFullScreen()){
                          this.exitFullscreen();
                      }
                      
                     this.player.pause()
                     this.$dialog.alert({
                       confirmButtonText:'我在，继续学习',
                       message: this.TrainBasicInfo.alertWindowTip || '亲爱的学员，还在吗？请不要走开，点击 ”我在“继续学习，否则您离开的时间将不计入学时',
                     })
                     .then(() => {
                      /** 如果正在人脸识别则不进行播放 */
                        if(!this.$parent.isfacedialog){
                          /** 点击我知道 重新给播放器赋值 */
                          this.isVideoTime = true;
                          this.player.seek(sessionStorage.getItem('currentVideoTime'));
                          this.player.play();
                        }

                     })
                     this.timeTStr =  parseInt(this.player.getCurrentTime());
                 }
             }
         }
     },
     //判断进入退出全屏
     checkIsFullScreen() {
        const isFullScreen = document.fullscreen || document.mozFullScreen || document.webkitIsFullScreen;
        return isFullScreen == undefined ? false : isFullScreen;
      },
      /**
       * video 退出全屏问题
       */
       exitFullscreen() {
          if (document.exitFullscreen) {
              document.exitFullscreen();
          } else if (document.msExitFullscreen) {
              document.msExitFullscreen();
          } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
          } else if(document.oRequestFullscreen){
              document.oCancelFullScreen();
          }else if (document.webkitExitFullscreen){
              document.webkitExitFullscreen();
          }else{
              document.IsFullScreen = false;
          }
      },
     // 播放器
     /* eslint-disable */
     /**
      * source 播放信息
      * type 音频 视频类型
      */
     getAliplayer(source, videoInfo){
         let skinLayout = this.skinLayout;
         if(this.isAndroid){
             skinLayout = this.skinLayoutAndroid
         }
         if((this.currentlyPlay.studyInfo && this.currentlyPlay.studyInfo.studyProcess === 2) || !this.isDraw && !this.isAndroid){
             skinLayout = this.skinLayoutAndroid
         }
         const config = source.videoMeta.title.indexOf('m3u8') !== -1 ? {
             id: "J_prismPlayer", // 容器id
             vid : source.videoMeta.videoId,
             playauth : source.playAuth,
             cover: videoInfo.videoType.mediaType === 'audio' ? this.audioImg : source && source.videoMeta &&  source.videoMeta.coverURL || this.audioImg,
             width: '100%',
             height: '210px',
             autoplay: true,
             rePlay: false,
             preload: true,
             controlBarVisibility: 'hover',
             useH5Prism: true,
             playsinline: true, //H5是否内置播放
             language: 'zh-cn',
             skinLayout
         } : {
             id: "J_prismPlayer", // 容器id
             vid : source.videoMeta.videoId,
             playauth : source.playAuth,
             cover: videoInfo.videoType.mediaType === 'audio' ? this.audioImg : source && source.videoMeta && source.videoMeta.coverURL || this.audioImg,
             format: videoInfo.videoType.format || 'm3u8',
             mediaType: videoInfo.videoType.mediaType || 'video',
             width: '100%',
             height: '210px',
             autoplay: true,
             rePlay: false,
             preload: true,
             controlBarVisibility: 'hover',
             useH5Prism: true,
             playsinline: true, //H5是否内置播放
             language: 'zh-cn',
             skinLayout
         }
            //  音频播放进度条和封面显示
            if(videoInfo.videoType.mediaType === 'audio'){
              this.$nextTick(() => {
                $('.prism-controlbar').css('display','inline-block')
                const cover = `<img src="${this.audioImg}" class="audioImg" alt="">`
                $('#J_prismPlayer').append(cover)
              })
            }
         // 视频清晰度
           if (videoInfo.videoType.mediaType !== 'audio') {
             config.definition = `LD,SD,HD,2K`
             config.defaultDefinition = videoInfo.videoClarity
           }
           console.log(config,'config=====')
             try {

                 // 课程 有观看记录
                 this.isReady = true
                 this.isOnce = true
                 this.player = new Aliplayer(config);

                 this.videoInfoNv.deadline = 0
                 this.videoInfoNv.video = document.querySelector('video') || document.querySelector('audio')
                 this.player.on('ready', () => {
                     /**
                      * 监管-弹屏次数
                      * 根据后端返回次数，总长度平均分配
                      * isAlertWindow: 弹屏开启 1 开启 0 关闭
                      * alertCount：弹屏次数
                      * alertType：弹屏类型 1 按次数 0 按时间
                      */
                     if(
                      this.TrainBasicInfo.isAlertWindow
                      && this.TrainBasicInfo.alertType
                      &&(!this.currentlyPlay.studyInfo || (this.currentlyPlay.studyInfo.learnRate||0) < 100)
                    ){
                         this.getShowAlertArrNum(this.player.getDuration(),this.TrainBasicInfo.alertCount)
                     }
                     this.$emit('ready')

                 })
                 this.player?.on('play', async () => {
                    // this.isReady = true;
                    // this.isOnce = true;
                    localStorage.setItem('videoTime',this.videoInfoNv.video.currentTime)
                     //   后台设置防倍速 指对视频生效
                    //  console.log(this.isDoubleSpeed,'this.isDoubleSpeed')
                     if( this.isDoubleSpeed && document.querySelector('video')){
                         document.querySelector('.prism-setting-speed').style = 'display:none';
                     }
                    //  if( (this.currentlyPlay.studyInfo && this.currentlyPlay.studyInfo.learnRate < 100) && !this.isAndroid && this.isDraw){
                    //      this.isPlay = true;
                    //  }else {
                    //      this.isPlay = false;
                    //  }
                     this.$emit('play');
                 });
                // canplay 能够开始播放音频和视频时发生，会多次触发，仅H5播放器。
                 this.player.on('canplay' , () => {
                     if(this.isReady){
                         // this.isReady = false
                         let  playLength = this.currentlyPlay.studyInfo && this.currentlyPlay.studyInfo.playLength
                         if((this.currentlyPlay.duration === playLength)||(this.currentlyPlay.duration - playLength<2)){
                             this.player.seek(1);
                             return;
                         }
                         this.player.seek(this.currentlyPlay.studyInfo && this.currentlyPlay.studyInfo.playLength);
                     }
                     // 兼容ios 不能自动播放  https://developer.aliyun.com/article/687095
                     if(this.isOnce){
                         if(this.currentlyPlay.duration === (this.currentlyPlay.studyInfo && this.currentlyPlay.studyInfo.playLength)){
                             this.player.seek(1);
                             return;
                         }
                         this.player.seek(this.currentlyPlay.studyInfo && this.currentlyPlay.studyInfo.playLength);
                         return
                     }


                 })

                 this.player.on("autoplay", (data) => {
                     if(data.paramData) {
                         // 兼容ios seek()方法  https://developer.aliyun.com/article/687095
                         this.isOnce = false
                     }
                 })

                 // 记录播放时间节点(秒)
                 this.starNotTime = 0
                 let _seek = this.player.seek
                 this.player.seek =  (time) => {
                     // 视频拖拽以后把弹窗的临时时间重制
                     this.timeTStr =0;
                     console.log(this.currentlyPlay.studyInfo,'this.currentlyPlay.studyInfo');
                     console.log(this.isDraw,'isDraw')
                     // 用户可以拖动进度条 (有观看记录 并且 观看记录已经完成 || 后台设置可以拖动进度条  )
                     if((this.currentlyPlay.studyInfo && this.currentlyPlay.studyInfo.studyProcess === 2) || !this.isDraw){
                         _seek.call(this.player, time);
                         return
                     }

                     if(this.isOnce){
                         // 兼容ios 不能自动播放  https://developer.aliyun.com/article/687095
                         this.isOnce = false
                         _seek.call(this.player, time)
                         return
                     }
                     if(this.isReady){
                         // 课程 有观看记录 只执行一次
                         _seek.call(this.player, time)
                         return
                     }
                     // 拖动时间>当前时间 并且 播放时间节点 < 拖动时间
                     console.log('time',time,this.player.getCurrentTime(),this.starNotTime);
                     console.log(this.isVideoTime,'isVideoTime')
                     if ((time >= this.player.getCurrentTime() || this.starNotTime > time) && !this.isVideoTime) {
                         this.player.pause()
                         Toast("学习期间不可拖动进度条")
                         _seek.call(this.player, this.player.getCurrentTime())
                     } else {
                         _seek.call(this.player, time)
                     }
                 }

                 // 当前播放时间
                 this.player?.on("timeupdate", () => {
                    // 播放进度实时
                     this.$emit('timeupdate')
                   /**
                    * 设置按次数弹屏
                    * 如果弹屏开始并且是按次数
                    * 首次进入弹屏
                    */
                   // && (+this.$route.query.studyProcess || 0) < 100
                   // console.log(this.TrainBasicInfo.isAlertWindow,'this.TrainBasicInfo.isAlertWindow',this.TrainBasicInfo.alertType )
                   if(this.TrainBasicInfo.isAlertWindow && this.TrainBasicInfo.alertType ){
                       console.log('设置弹屏！！！！！！')
                       this.setDialogNum()
                   }
                     // // 弹屏设置
                     //  this.setDialogNum()
                     this.isReady = false;
                    //  console.log('starNotTime',this.starNotTime)
                     if (this.starNotTime < this.player.getCurrentTime()) {
                         this.starNotTime = this.player.getCurrentTime() | 0
                     }
                 })

                 this.player?.on('pause', async (e) => {
                    this.isOnce = false;
                    this.isReady = false;
                     // 视频暂停
                     this.$emit('pause')
                 });

                 this.player?.on('ended', async (e) => {
                     this.isPlay = false
                     this.videoInfoNv.deadline = 0
                     // 结束
                     this.$emit('ended')
                 });

                 /**
                  * 监听等待缓冲 当前进度存本地
                  */
                 this.player?.on('waiting', async (e) => {
                     let video = document.querySelector('video')
                     if (+this.currentlyPlay.type === 2 || +this.currentlyPlay.courseType === 2) {
                         video = document.querySelector('audio')
                     }
                     const cur = video && video.currentTime;
                     if(cur){
                         localStorage.setItem('videoTime',cur)
                     }
                 });
                 this.player?.on('error', async (e) => {
                     let video = document.querySelector('video');
                     if (+this.currentlyPlay.type === 2 || +this.currentlyPlay.courseType === 2) {
                         video = document.querySelector('audio');
                     }
                     const cur = video && video.currentTime;
                     if(cur){
                         localStorage.setItem('videoTime',cur)
                     }
                 });

                 // 获取已经学习的进度
                 if(this.currentlyPlay){
                     this.progressSetting(this.currentlyPlay)
                 }

                 this.player.on("requestFullScreen",()=>{
                     this.isScreen = true
                 })
                 console.log(this.player.fullscreenService.getIsFullScreen(),'getIsFullScreen')
                 console.log(this.isScreen,'isScreen===')
                 console.log(this.checkIsFullScreen(),'checkIsFullScreen')
                 // 全屏并且是安卓系统
                 if(this.isAndroid && this.player.fullscreenService.getIsFullScreen()){
                     this.videoInfoNv.video.addEventListener('timeupdate', () => {
                       console.log(this.videoInfoNv.video.currentTime,'this.videoInfoNv.video.currentTime===')
                       this.startTime = Math.floor(this.videoInfoNv.video.currentTime)
                       this.TimeArray.push(this.startTime)
                       this.TimeArray = Array.from(new Set(this.TimeArray))

                       if (this.TimeArray.length) {
                           this.frontTime = this.TimeArray[this.TimeArray.length - 2] || 0
                       }

                       this.videoInfoNv.deadline = this.videoInfoNv.video.currentTime + 3
                   })
                   this.videoInfoNv.video.addEventListener('seeking', () => {
                       console.log(this.videoInfoNv.video.currentTime,'this.videoInfoNv.video.currentTime===')

                       this.startTime = this.videoInfoNv.video.currentTime;
                       // 用户可以拖动进度条 (有观看记录 并且 观看记录已经完成 || 后台设置可以拖动进度条  )
                       if((this.currentlyPlay.studyInfo && this.currentlyPlay.studyInfo.studyProcess === 2) || !this.isDraw){
                           return
                       }

                       // 向后拖动进度条
                       if (this.player.getCurrentTime() > (this.videoInfoNv.deadline || 0) && !this.isVideoTime) {
                           this.videoInfoNv.video.currentTime = this.videoInfoNv.deadline - 3.3

                           if(this.theFirst){
                               // 首次跳转卜建婷
                               this.theFirst = false
                               return
                           }
                           this.player.pause()
                           Toast("学习期间不可拖动进度条")
                       }
                       // 向前拖动进度条
                       if(this.player.getCurrentTime() < this.frontTime && !this.isVideoTime) {
                           this.videoInfoNv.video.currentTime = this.frontTime
                           this.player.pause()
                           Toast("学习期间不可拖动进度条")
                       }
                   })
                 }


             }catch(error){
                 console.log(error,'error====');

             }
     },

     progressSetting(dataInfo) {
         if (dataInfo && dataInfo.studyInfo) {
             // 当前进度率
             const deadline = (this.player.getDuration() || dataInfo.duration || 0) * ((dataInfo.studyInfo.learnRate || 0) * .01)

             // 当前课程 是否学习完
             this.videoInfoNv.deadline = deadline >= (this.player.getDuration() || dataInfo.duration || 0) ? this.player.getDuration() : deadline

             // // 当前课程 是否学习过(服务端存储的进度)
             // if (dataInfo.studyInfo.playLength) {
             //     if(dataInfo.duration === dataInfo.studyInfo.playLength){
             //         this.videoInfoNv.video.currentTime  = 1
             //         return
             //     }
             //     this.videoInfoNv.video.currentTime = dataInfo.studyInfo.playLength
             // } else {
             //     this.videoInfoNv.video.currentTime = (this.videoInfoNv.deadline >= (this.player.getDuration() || dataInfo.duration || 0) ? 0 : this.videoInfoNv.deadline || 0)
             // }
         }
     }

 },

}
</script>

<style lang="less" scoped>
.play_warp{
 position: relative;
 // transform: rotate(90deg);
 .block_module {
     position: absolute;
     width: 8vw;
     height: 4vh;
     z-index: 999999999;
     bottom: 13px;
     right: 80PX;
     display: flex;
     align-items: center;
     justify-content: center;
     .shrink {
         font-size: 25PX;
         color: #fff;
     }
 }

}
/****  隐藏音轨和字幕 */
/deep/.prism-setting-cc,/deep/.prism-setting-audio{
 display: none;
}
.orienta {
 /deep/ .prism-player .prism-play-btn{
     margin-left: 62px !important;
 }
}
</style>
